import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { __t } from '@mssgme/shared';
import { LandingsPropTypes } from '@mssgme/ui';
import { useModalThemes } from '../../../hooks';
import { ThemedButton } from '../../../UI';

const propTypes = {
    order: LandingsPropTypes.order.isRequired,
    onPay: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export function CashOnDeliveryPayment({ disabled, onPay }) {
    const { contentStyle } = useModalThemes();

    const handleOrder = useCallback(() => onPay('cod'), [onPay]);

    return (
        <ThemedButton fullWidth theme={contentStyle} disabled={disabled} onClick={handleOrder}>
            {__t('make_order')}
        </ThemedButton>
    );
}

CashOnDeliveryPayment.propTypes = propTypes;
